import { defineStore } from 'pinia'
import { ref, reactive } from 'vue'
import {  generateUserInfo } from '@/mock'

export const useUserStore = defineStore('user', () => {
  const isLoggedIn = ref(!!localStorage.getItem('isLoggedIn'))

  const savedUsername = localStorage.getItem('username') || ''
  const userInfo = reactive(
    savedUsername ? generateUserInfo(savedUsername) : { username: '', nickname: '', email: '', phone: '', avatar: '' }
  )


  function login(username) {
    // isLoggedIn.value = true
    const info = generateUserInfo(username)
    Object.assign(userInfo, info)
    // localStorage.setItem('isLoggedIn', 'true')
    localStorage.setItem('username', username)
    localStorage.setItem('nickname', username)
  }

  function logout() {
    // isLoggedIn.value = false
    userInfo.username = ''
    userInfo.nickname = ''
    // localStorage.removeItem('isLoggedIn')
    // localStorage.removeItem('username')
    localStorage.removeItem('userToken')
    localStorage.removeItem('nickname')
  }

  return {
    isLoggedIn,
    userInfo,
    // notice,
    // packages,
    // downloadRecords,
    // addRecord,
    // activatePackage,
    // changePassword,
    // updateUserInfo,
    login,
    logout
  }
})
